<script type="text/javascript">
import axios from "axios";

import store from "./store";
import router from './router'


const SERVER_API_BASE_URL = "/api";

let SERVER_OFFLINE = false;
let SERVER_SUBFILE = '/';
let SERVER_BASE_URL;
let SERVER_WEB_URL;
let SERVER_FRONT_WEB_URL;//当前项目的观看地址
let SERVER_PAY_WEB_URL = "https://api.vjoevr.com";
let WEICHAT_APPID;
let WEICHAT_URL;



// 配置axios请求的地址
// if (process.env.NODE_ENV === 'production') {
	// -----线上地址------
  SERVER_BASE_URL = "https://api.vjoevr.com";
  SERVER_WEB_URL = "https://api.vjoevr.com";
  SERVER_FRONT_WEB_URL = "https://hall.vjoevr.com/#/watch";
	WEICHAT_APPID = 'wxe4c1652b7d609022';
	WEICHAT_URL = 'http://data.vjoevr.com/data/common/get-weixin-code.html';
	
	
	

	// SERVER_BASE_URL = "http://api.vrproperty.cn";
	// SERVER_WEB_URL = "http://api.vrproperty.cn";
	// SERVER_FRONT_WEB_URL = "http://hall.vrproperty.cn";
	// WEICHAT_APPID = 'wx2f834362b6ae917b';
	// WEICHAT_URL = 'http://data.vrproperty.cn/get-weixin-code.html';
  // axios.defaults.baseURL = SERVER_BASE_URL;
// } 
// else {
  // SERVER_BASE_URL = "http://localhost:8086";
  // SERVER_WEB_URL = "http://localhost:8086";
  // SERVER_FRONT_WEB_URL = "http://localhost";
	 
	// SERVER_BASE_URL = "https://testapi.vjoevr.com";
 //  SERVER_WEB_URL = "https://testapi.vjoevr.com";
 //  SERVER_FRONT_WEB_URL = "https://testhall.vjoevr.com";
	 
	// SERVER_BASE_URL = "http://sunshinebackend.natapp4.cc";
	// SERVER_WEB_URL = "http://sunshinebackend.natapp4.cc";
	// SERVER_FRONT_WEB_URL = "http://sunshinebackend.natapp4.cc";
	
  axios.defaults.baseURL = SERVER_BASE_URL;
// }
axios.defaults.timeout = 300000; // 超时时间
axios.defaults.headers.post["Content-Type"] =
  "application/json; charset=utf-8;";
// application/x-www-form-urlencoded;
axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true; //axios默认是发送请求的时候不会带上cookie的


export default {
  axios,
  store,
	SERVER_OFFLINE,
  SERVER_API_BASE_URL,
  SERVER_BASE_URL,
  SERVER_WEB_URL,
  SERVER_FRONT_WEB_URL,
	SERVER_PAY_WEB_URL,
	SERVER_SUBFILE,
	WEICHAT_APPID,
	WEICHAT_URL
	
};
</script>
